import { RequireAuth } from 'common/auth';
import LayoutBase from 'common/layouts/base-layout/LayoutBase';
import LoginLayoutBase from 'common/layouts/base-layout/LoginLayoutBase';
import { ChangePasswordEntry } from 'features/change-password/entries';
import { LoginEntry } from 'features/login/entries';
import { LogoutEntry } from 'features/logout/entries';
import { NotFoundEntry } from 'features/not-found/entries';
import { RemoteCollectionEntry } from 'features/remote-collection/entries';
import { ResetPasswordEntry } from 'features/reset-password/entries';
import { Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router';

import {
  CHANGE_PASSWORD_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  REMOTE_COLLECTION_PATH,
  RESET_PASSWORD_PATH,
} from './paths/paths';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        element={
          <Suspense fallback={null}>
            <LoginLayoutBase />
          </Suspense>
        }
      >
        <Route path={LOGIN_PATH} element={<LoginEntry />} />
        <Route path={RESET_PASSWORD_PATH} element={<ResetPasswordEntry />} />
        <Route path={CHANGE_PASSWORD_PATH} element={<ChangePasswordEntry />} />
      </Route>

      <Route element={<RequireAuth />}>
        <Route
          element={
            <Suspense fallback={null}>
              <LayoutBase />
            </Suspense>
          }
        >
          <Route index path={REMOTE_COLLECTION_PATH} element={<RemoteCollectionEntry />} />
        </Route>
      </Route>
      <Route path={LOGOUT_PATH} element={<LogoutEntry />} />
      <Route path='*' element={<NotFoundEntry />} />
    </>,
  ),
);
